var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"secondary--text",attrs:{"color":_vm.footerColor}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" Copyright © "+_vm._s(_vm.anio)+". Todos los derechos reservados - IT Management ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }